const iySP = {
  studioId: 'iy-sp',
  studioName: 'Iyengar Yoga St. Petersburg',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://iy-sp.com/api',
  siteUrl: 'https://iy-sp.com',
  // Studios sharing this backend; the class form shows a Studio picker when there's more than one.
  sharedStudios: [{ id: 'iy-sp', label: 'IY-SP' }, { id: 'flourish', label: 'Flourish' }],
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  zoomHostLink: process.env.REACT_APP_ZOOM_HOST_LINK,
  theme: {
    '--primary-hue':           '330',
    '--grey-hue':              '300',
    '--color-primary':         'hsl(330, 50%, 90%)',
    '--color-primary-variant': 'hsl(330, 90%, 40%)',
    '--color-secondary':       '#e58684',
    '--color-tertiary':        '#842953',
    '--color-hybrid':          '#D6297A',
    '--color-grey-100':        'hsl(300, 47%, 94%)',
    '--color-grey-200':        'hsl(300, 26%, 75%)',
    '--color-grey-300':        'hsl(300, 24%, 64%)',
    '--color-grey-400':        'hsl(300, 16%, 41%)',
    '--color-grey-500':        'hsl(300, 44%, 25%)',
    '--color-grey-600':        'hsl(300, 48%, 15%)',
  },
  venues: [
  { id: "venue_001", name: "Soley Massage & Wellness", address: "2963 46th Ave N, St. Petersburg, FL 33714" },
  { id: "venue_002", name: "", address: ""  },
  { id: "venue_online", name: "Online", address: null},
  ],
};

export default iySP;